import { FieldValues, UseFormRegister, UseFormReturn } from 'react-hook-form'
import { useCallback } from 'react'

import { extractInputError } from 'utils/formUtils/formErrorUtils'

import { ObjectSchemaOf } from './useYupForm'

export function useFormInputRegister<TFieldValues extends FieldValues, TContext extends object>(
  { register, formState }: Pick<UseFormReturn<TFieldValues, TContext>, 'register' | 'formState'>,
  schema?: ObjectSchemaOf<TFieldValues>,
): UseFormRegister<TFieldValues> {
  return useCallback(
    (name, options) => {
      const label = schema?.fields[name].spec.label
      return {
        ...register(name, options),
        // @ts-ignore
        ...extractInputError(formState.errors[name]),
        ...(label && { label }),
      }
    },
    [formState.errors, register, schema?.fields],
  )
}
